<button [ngClass]="buttonClass" (click)="customFunctiionName()"  type={{buttonType}}  [disabled]=buttonDisabled role=buttonRole id={{buttonId}}> 
    <span  [ngClass]="iconEleClass" *ngIf="isIconVisible"></span>
    <span [ngClass]="titleEleClass" *ngIf="isTitleVisible" >{{title | translate }} </span>
</button>
